import React from "react";
import TableComponent, {
  TableComponent2colm,
} from "../Components/TableComponent";

//internal quality assurance comitte
export function Initiatives() {
  const userData = [
    {
      NameOfTheMember: "Dr.Aruna Deoskar",
      Designation: "Director",
      PositionInTheCommittee: "Chairman, Head of the Institution ",
    },
    {
      NameOfTheMember: "Dr. Gajanan Badhe",
      Designation: "Associate Professor",
      PositionInTheCommittee: "Member Teaching Faculty",
    },
    {
      NameOfTheMember: "Mrs.Bharati Ramageri",
      Designation: "Assistant Professor",
      PositionInTheCommittee: "Member Teaching faculty ",
    },
    {
      NameOfTheMember: "Dr. Prasad Ghodake",
      Designation: "Assistant Professor",
      PositionInTheCommittee: "Member Teaching faculty ",
    },
    {
      NameOfTheMember: "Prof. Leena Deshmukh",
      Designation: "Assistant Professor",
      PositionInTheCommittee: "Member Teaching faculty ",
    },
    {
      NameOfTheMember: "Dr. Milind Alandikar",
      Designation: "Visitor of the Institute",
      PositionInTheCommittee: "Management Representative",
    },
    {
      NameOfTheMember: "Mr.Prashant Markale",
      Designation: "Office Superintendent",
      PositionInTheCommittee: "Administrative Officer",
    },
    {
      NameOfTheMember: "Mrs. Aruna Kawathekar",
      Designation: "Assistant Librarian",
      PositionInTheCommittee: "Member Library",
    },
    {
      NameOfTheMember: "Mr.Chirantan Kulkarni",
      Designation: "Alumni",
      PositionInTheCommittee: "Member Alumni",
    },
    {
      NameOfTheMember: "Mr. Aditya Talape",
      Designation: "Student",
      PositionInTheCommittee: "Member Student",
    },
    {
      NameOfTheMember: "Ms. Pallavi Avhale",
      Designation: "Student",
      PositionInTheCommittee: "Member Student",
    },
    {
      NameOfTheMember: "Mr. Vijay Tarak",
      Designation: "Employer/Industrialis",
      PositionInTheCommittee: "Member Employer/Industrialist",
    },
    {
      NameOfTheMember: "Dr. Sudarshan Pawar",
      Designation: "Associate Professor",
      PositionInTheCommittee: "IQAC Coordinator",
    },
  ];

  const tableHeaders = {
    columns: [
      "Sr No.",
      "Name Of The Member",
      "Position In The Committee",
      "Authority",
    ],
  };

  return (
    <div>
      <TableComponent data={userData} headers={tableHeaders} />
    </div>
  );
}

export function StudentGrievanceData() {
  const userData = [
    {
      NameOfTheMember: "Dr. Aruna Deoskar",
      Designation: "Director",
      PositionInTheCommittee: "Chairman",
    },
    {
      NameOfTheMember: "Dr.Sudarshan Pawar",
      Designation: "IQAC Co-ordinator",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Prof. Dr. P.D. Chaoudhari",
      Designation: "PES Modern college of  Pharmacy",
      PositionInTheCommittee: "Ombudsman(appointed by SPPU ) ",
    },
    {
      NameOfTheMember: "Mrs. Aruna Kawathekar",
      Designation: "Non-teaching staff",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mrs.Snehal Padhye",
      Designation: "Non-Teaching staff",
      PositionInTheCommittee: "Member",
    },

    {
      NameOfTheMember: "Mr.Anurag Patil",
      Designation: "Student",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Miss. Pallavi Awhale",
      Designation: "Student",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Prof. Mahesh Salvi",
      Designation: "Teaching staff",
      PositionInTheCommittee: "Member Secretary",
    },
  ];

  const tableHeaders = {
    columns: [
      "Sr No.",
      "Name Of The Member",
      "Position In The Committee",
      "Authority",
    ],
  };

  return (
    <div>
      <TableComponent data={userData} headers={tableHeaders} />
    </div>
  );
}

export function InternalCommittee() {
  const userData = [
    {
      NameOfTheMember: "Dr. Aruna Deoskar",
      PositionInTheCommittee: "Chairperson",
      Designation: "Director",
    },
    {
      NameOfTheMember: "Dr.Sudarshan Pawar",
      Designation: "IQAC Co-ordinator",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mrs. Meena Kurlekar",
      Designation: "Director Vanchit Vikas (NGO)",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Dr.Bharati Ramageri",
      Designation: "Teaching staff",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Prof. Neha Gupte",
      Designation: "Teaching staff",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mr.Prashant Markale",
      Designation: "Non-teaching staff",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mrs.Snehal Padhye",
      Designation: "Non-teaching staff",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mrs. Aruna Kawathekar",
      Designation: "Non-Teaching staff",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mr. Tanmay Babar",
      Designation: "Student",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Miss.Bhagyashree Mahajan",
      Designation: "Student",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Miss. Chaitrali Sutar",
      Designation: "Student",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mr. Aditya Talape",
      Designation: "Student",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Prof. Madhuri Dambal",
      Designation: "Teaching Staff",
      PositionInTheCommittee: "Member Secretary",
    },
  ];

  const tableHeaders = {
    columns: [
      "Sr No.",
      "Name Of The Member",
      "Position In The Committee",
      "Authority",
    ],
  };

  return (
    <div>
      <TableComponent data={userData} headers={tableHeaders} />
    </div>
  );
}

export function ANTI_RAGGING() {
  const userData = [
    {
      NameOfTheMember: "Dr.Aruna Deoskar",
      Designation: "Director",
      PositionInTheCommittee: "Chairman",
    },
    {
      NameOfTheMember: "Dr.Sudarshan Pawar",
      Designation: "IQAC Co-ordinator",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mr. Shatrughan Mali",
      Designation: "Sr. P.I .Nigdi",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mrs. Bharati Ramageri",
      Designation: "Teaching staff",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mr. Prashant Markale",
      Designation: "Non-Teaching staff",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mr.Anurag Patil",
      Designation: "Student-Representative",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Miss. Pallavi Awhale",
      Designation: "Student-Representative",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mr.Sunil Bhilavade",
      Designation: "Student-Representative",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Prof. Gajanan Badhe",
      Designation: "Teaching Staff",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Prof. Neha Gupte",
      Designation: "Teaching Staff",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mrs. Aruna Kawathekar",
      Designation: "Non-Teaching Staff",
      PositionInTheCommittee: "Member",
    },
    {
      NameOfTheMember: "Mr .Mahesh Salvi",
      Designation: "Teaching staff",
      PositionInTheCommittee: "Member-Secretary",
    },
  ];

  const tableHeaders = {
    columns: [
      "Sr No.",
      "Name Of The Member",
      "Position In The Committee",
      "Authority",
    ],
  };

  return (
    <div>
      <TableComponent data={userData} headers={tableHeaders} />
    </div>
  );
}

export function CommitteeData() {
  const userData = [
    {
      col1: "Dr.Aruna Deoskar",
      col2: "Chairperson",
      col3: "Director",
    },
    {
      col1: "Dr. Sudarshan Pawar",
      col2: "Member",
      col3: "Co-ordinator, MIBS",
    },
    {
      col1: "Dr.Bharati Ramageri",
      col2: "Member",
      col3: "Teaching- Staff",
    },
    {
      col1: "Mr.Prashant Markale",
      col2: "Member",
      col3: "Non – Teaching staff",
    },
    {
      col1: "Ms.Shrutika Dhadse",
      col2: "Member",
      col3: "Student Representative",
    },
    {
      col1: "Mr.Anurag Patil",
      col2: "Member",
      col3: "Student Representative",
    },
    {
      col1: "Ms.Anisha Tandale",
      col2: "Member",
      col3: "Student Representative",
    },
    {
      col1: "Mr. Santosh Bagav",
      col2: "Member-Secretary",
      col3: "Librarian",
    },
  ];

  const tableHeaders = {
    columns: [
      "Sr No.",
      "Name of the member",
      "Position in the Committee",
      "Authority",
    ],
  };

  return (
    <div>
      <TableComponent2colm data={userData} headers={tableHeaders} />
    </div>
  );
}

export function ANTIRAGGING_SQUAD() {
  const userData = [
    {
      col1: "Prof. Neha Gupte ",
      col2: "Squad",
      col3: "Teaching Staff",
    },
    {
      col1: "Mr. Prashant Markale",
      col2: "Squad",
      col3: "Non-Teaching Staff",
    },
    {
      col1: "Mrs. Aruna Kawathekar",
      col2: "Squad",
      col3: "Non-Teaching Staff",
    },
  ];

  const tableHeaders = {
    columns: [
      "Sr No.",
      "Name of the member",
      "Position in the Committee",
      "Authority",
    ],
  };

  return (
    <div>
      <TableComponent2colm data={userData} headers={tableHeaders} />
    </div>
  );
}

export function EQUALCELL() {
  const userData = [
    {
      col1: "डॉ. अरुणा देओसकर",
      col2: "समन्वय अधिकारी",
      col3: "९८२२७९६५४०",
    },
    {
      col1: "श्री. प्रशांत मरकळे  ",
      col2: "समन्वय सहाय्यक",
      col3: "७०३८५०००३०",
    },
    {
      col1: "सौ. स्वाती गाढवे ",
      col2: "समन्वय सहाय्यक",
      col3: "७७०९०७७९७२",
    },
    {
      col1: "गायत्री संजय पोटे ",
      col2: "(सदस्य ओ.बी.सी )",
      col3: "८४४६१०२१३६",
    },
    {
      col1: "आरती राजकुमार शिंदे",
      col2: "( सदस्य व्ही.जे.एन.टी )",
      col3: "९०२२४४५८०७",
    },
    {
      col1: "पल्लवी विजय आवाळे ",
      col2: "(सदस्य ई.बी.सी )",
      col3: "९५२७२०३०८३",
    },
    {
      col1: "राठोड प्रकाश सुरज ",
      col2: "( सदस्य व्ही.जे.एन.टी )",
      col3: "९६२३९२७३८९",
    },
    {
      col1: "सायली अशोक साने ",
      col2: "( सदस्य खुला)",
      col3: "९१४६३१३५२०",
    },
    {
      col1: "भूषण शेषराव इंगळे",
      col2: "( सदस्य एस.सी )",
      col3: "९०२१७८५९९१",
    },
    {
      col1: "तेजस रामचंद्र गांगुर्डे ",
      col2: "( सदस्य एस.टी )",
      col3: "७०८३२५५२२७",
    },
    {
      col1: "जयदीप दिलीप कायस्थ ",
      col2: "( सदस्य ई.डब्लू.एस )",
      col3: "८६६९८६३०५९",
    },
  ];

  const tableHeaders = {
    columns: ["अ.क्र", "नाव", "पद", "मोबाइल क्र"],
  };

  return (
    <div>
      <TableComponent2colm data={userData} headers={tableHeaders} />
    </div>
  );
}

export function DivyangCellTable() {
  const userData = [
    {
      col1: "Dr. Aruna Deoskar",
      col2: "Chairman",
      col3: "Director",
    },
    {
      col1: "Dr.Sudarshan Pawar",
      col2: "Member",
      col3: "Co-ordinator",
    },
    {
      col1: "Dr.Bharati Ramageri",
      col2: "Member",
      col3: "Teaching Staff",
    },
    {
      col1: "Mr.Santosh Bagav",
      col2: "Member",
      col3: "Non-Teaching Staff",
    },
    {
      col1: "Prof.Mahesh Salvi",
      col2: "Member Secretary",
      col3: "Teaching Staff",
    },
    
  ];

  const tableHeaders = {
    columns: ["Sr No.", "Name of the Member", "Position in the Committee", "Authority"],
  };

  return (
    <div>
      <TableComponent2colm data={userData} headers={tableHeaders} />
    </div>
  );
}

export function STUDENTCOUNCIL() {
  const userData = [
    {
      col1: "Srujan Boriwar ",
      col2: "MBA I",
      col3: "President",
    },
    {
      col1: "Amrut Dhapadhule",
      col2: "MCA I",
      col3: "Secretary",
    },
    {
      col1: "Nikita Choudhary",
      col2: "MBA I",
      col3: "Member",
    },
    {
      col1: "Chaitrali Sutar",
      col2: "MBA I",
      col3: "Member",
    },
    {
      col1: "Aditya Talpade",
      col2: "MBA I",
      col3: "Member",
    },
    {
      col1: "Chanchal Dhanve",
      col2: "MCA I",
      col3: "Member",
    },
    {
      col1: "Janhavi Limkar",
      col2: "BCA I",
      col3: "Member",
    },
    {
      col1: "Nayan Londhe",
      col2: "BCA I",
      col3: "Member",
    },
  ];

  const tableHeaders = {
    columns: ["Sr No.", "Name of the Student", "Class", "Designation"],
  };

  return (
    <div>
      <TableComponent2colm data={userData} headers={tableHeaders} />
    </div>
  );
}

export function GOVERNINGCOUNCIL() {
  const userData = [
    {
      col1: "Prof.Dr. Gajanan Ekbote",
      col2: "Chairperson",
      col3: "Management",
    },
    {
      col1: "Prof.Shamkant Deshmukh",
      col2: "Member",
      col3: "Management",
    },
    {
      col1: "Prof.Dr.Nivedita G. Ekbote",
      col2: "Member",
      col3: "Management",
    },
    {
      col1: "Prof. Dr. Sanjay Kharat ",
      col2: "Member",
      col3: "Management",
    },
    {
      col1: "Prof. Dr. Pravin Chaudhary ",
      col2: "Member",
      col3: "Management",
    },
    {
      col1: "Dr. Sudarshan Pawar",
      col2: "Member",
      col3: "Institute Teacher",
    },
    {
      col1: "Prof. Dr. Mandakini Bhosale ",
      col2: "Member",
      col3: "Institute Teacher",
    },
    {
      col1: "Mr. Prashant Markale ",
      col2: "Member",
      col3: "Admin Staff",
    },
    {
      col1: "Prof. Dr. Ravindra Vaidya ",
      col2: "Member",
      col3: "Educationalist",
    },
    {
      col1: "Prof. Dr. Dattatray Mane ",
      col2: "Member",
      col3: "VC Nominee",
    },
  ];

  const tableHeaders = {
    columns: ["Sr No.", "Name", "Designation", ""],
  };

  return (
    <div>
      <TableComponent2colm data={userData} headers={tableHeaders} />
    </div>
  );
}

export function Academic_Council() {
  const userData = [
    {
      col1: "Dr.Aruna Deoskar",
      col2: "Chairperson",
    },
    {
      col1: "Prof. Dr. Supriya Patil",
      col2: "VC Nominee",
    },
    {
      col1: "Prof. Dr. Mahesh Abale",
      col2: "VC Nominee",
    },
    {
      col1: "Prof. Dr. Dhananjay Mandlik",
      col2: "VC Nominee",
    },
    {
      col1: "Mr. Sagar Malpore",
      col2: "Subject Expert",
    },
    {
      col1: "Mr. Arirban Mukharji",
      col2: "Subject Expert",
    },
    {
      col1: "Mr. Prashant Telang",
      col2: "Subject Expert",
    },
    {
      col1: "Mr. Tushar Kute",
      col2: "Subject Expert",
    },
    {
      col1: "Dr. Ananya Bibwe",
      col2: "Subject Expert",
    },
    {
      col1: "Prof. Bharati Armani",
      col2: "Member",
    },
    {
      col1: "Dr. Prasad Ghodke",
      col2: "Member",
    },
    {
      col1: "Prof. Mahesh Salvi",
      col2: "Member",
    },
    {
      col1: "Prof. Neha Gupte",
      col2: "Member",
    },
    {
      col1: "Prof. Gajanan Badhe",
      col2: "CEO",
    },
    {
      col1: "Dr. Sudarshan Pawar",
      col2: "Member Secretary",
    },
  ];

  const tableHeaders = {
    columns: ["Sr No.", "Name of the member", "Designation"],
  };

  return (
    <div>
      <TableComponent2colm data={userData} headers={tableHeaders} />
    </div>
  );
}

export function BOSMembersMBA() {
  const userData = [
    {
      col1: "Dr.Aruna Deoskar",
      col2: "Director",
    },
    {
      col1: "Dr. Sudarshan Pawar",
      col2: "Chairperson",
    },
    {
      col1: "Dr. Rajesh Pahurkar",
      col2: "VC Nominee",
    },
    {
      col1: "Dr. Madhavi Deshpande",
      col2: "External Subject Expert",
    },
    {
      col1: "Dr. Madhur Pranjal",
      col2: "External Subject Expert",
    },
    {
      col1: "Mr. Prashant Telang",
      col2: "Industry Representative",
    },
    {
      col1: "CMA Sagar Malpure",
      col2: "Industry Representative",
    },
    {
      col1: "Mr. Navnath Suryawanshi",
      col2: "Industry Representative",
    },
    {
      col1: "Dr. Satish Dingare",
      col2: "Industry Representative",
    },
    {
      col1: "Mr. Vaibhav Solat",
      col2: "Industry Representative",
    },
    {
      col1: "Mr. Pushkar Aurangabadkar",
      col2: "Alumni",
    },
    {
      col1: "Prof. Darshan Mejari",
      col2: "Subject Expert",
    },
    {
      col1: "Dr. Prasad Ghodke",
      col2: "Subject Expert",
    },
    {
      col1: "Prof. Smita Sonawane",
      col2: "Subject Expert",
    },
    {
      col1: "Prof. Neha Gupte",
      col2: "Subject Expert",
    },
    {
      col1: "Prof. Rupali Jadhav",
      col2: "Subject Expert",
    },
    {
      col1: "Prof. Madhuri Dambal",
      col2: "Subject Expert",
    },
  ];

  const tableHeaders = {
    columns: ["Sr No.", "Name of the member", "Designation"],
  };

  return (
    <div>
      <TableComponent2colm data={userData} headers={tableHeaders} />
    </div>
  );
}

export function BOSMembersMCABCA() {
  const userData = [
    {
      col1: "Dr.Aruna Deoskar",
      col2: "Chairperson",
    },
    {
      col1: "Dr Manisha Kumbhar",
      col2: "VC Nominee",
    },
    {
      col1: "Dr. Ajit More",
      col2: "External Subject Expert",
    },
    {
      col1: "Dr Shubhalaxmi Joshi",
      col2: "External Subject Expert",
    },
    {
      col1: "Mr Rahul Teni",
      col2: "Industry Representative",
    },
    {
      col1: "Mr Tushar Kute",
      col2: "Industry Representative",
    },
    {
      col1: "Mr Yogesh Navle",
      col2: "Industry Representative",
    },
    {
      col1: "Prof. Bharati Ramageri",
      col2: "Subject Expert",
    },
    {
      col1: "Prof Gajanan Badhe",
      col2: "Subject Expert",
    },
    {
      col1: "Prof Leena Deshmukh",
      col2: "Subject Expert",
    },
    {
      col1: "Prof Uma Patil",
      col2: "Subject Expert",
    },
    {
      col1: "Prof Mahesh Salvi",
      col2: "Subject Expert",
    },
  ];

  const tableHeaders = {
    columns: ["Sr No.", "Name of the member", "Designation"],
  };

  return (
    <div>
      <TableComponent2colm data={userData} headers={tableHeaders} />
    </div>
  );
}
